export default {"src":"/_next/static/media/user-search.2304c251.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};